import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { domain } from 'shared/settings';
import { getTimeFromUTCToTimezone } from 'shared/utils/getTimeFromUTCToTimezone';

dayjs.extend(customParseFormat);

export class BonusProgramConverter {
  convertCurrentGifts = d => {
    const items =
      d?.gifts?.map(t => ({
        id: t.id,
        name: t.name,
        imageUrl: `${domain}/${t.image_url}`,
        points: t.point_cost,
        description: t.description ?? '',
        active: t.status,
      })) || [];

    return {
      items: items,
      count: d.count,
    };
  };

  convertRequests = d => {
    const items =
      d?.gift_requests?.map(t => ({
        id: t.id,
        userId: t.user_id,
        giftId: t.gift_id,
        date: dayjs(t.requested_at).format('DD/MM/YY'),
        points: t.amount_point_paid,
        status: t.status,
        username: t.username,
        giftName: t.gift_name,
        comment: t.comment,
        name: t.name,
        last_name: t.last_name,
        dni: t.dni,
        phone: t.phone,
        address: t.address,
      })) || [];

    return {
      items: items,
      count: d.count,
    };
  };

  convertChristmasTournament = d => {
    const items = d?.top10.map(t => ({
      username: t.username,
      points: t.points,
      position: t.position,
    }));

    const agentData = d?.agent_data;

    return {
      items,
      agentData: {
        username: agentData?.username || '',
        points: agentData?.points || -1,
        position: agentData?.position || -1,
      },
    };
  };

  convertJacktopTournament = d => {
    const items = d?.top_agents?.map(t => ({
      username: t.username,
      points: t.points,
      position: t.position,
    })) || [];

    const agentData = d?.agent_data;

    return {
      items,
      agentData: {
        username: agentData?.username || '',
        points: agentData?.points || -1,
        position: agentData?.position || -1,
      },
    };
  };

  convertRubyPlayTournament = d => {
    const items = d?.top_agents?.map(t => ({
      username: t.username,
      points: t.points,
      position: t.position,
    })) || [];

    const agentData = d?.agent_data;

    return {
      items,
      agentData: {
        username: agentData?.username || '',
        points: agentData?.points || -1,
        position: agentData?.position || -1,
      },
    };
  };
  convertNetentTournament = d => {
    const items = d?.top_agents?.map(t => ({
      username: t.username,
      points: t.points,
      position: t.position,
    })) || [];

    const agentData = d?.agent_data;

    return {
      items,
      agentData: {
        username: agentData?.username || '',
        points: agentData?.points || -1,
        position: agentData?.position || -1,
      },
    };
  };

  convertPromotions = d => {
    const items = d?.promotions.map(t => ({
      callAction: t.call_action,
      description: t.description,
      header: t.header,
      id: t.id,
      isActive: String(t.is_active).toLowerCase() === 'true',
      lang: t.lang,
      publicationDate: getTimeFromUTCToTimezone(dayjs(t.publication_date, 'YYYY-MM-DDTHH:mm:ss.ssssss'))?.format(
        'DD.MM.YYYY HH:mm',
      ),
      selfDeletionDate: getTimeFromUTCToTimezone(dayjs(t.self_deletion_date, 'YYYY-MM-DDTHH:mm:ss.ssssss'))?.format(
        'DD.MM.YYYY HH:mm',
      ),
      shortDescription: t.short_description,
      url: t.url,
      urlImage: t.url_image,
      urlMiniImage: t.url_mini_image,
    }));

    return {
      items: items,
      count: d.count,
    };
  };

  convertPromotionById = d => {
    return {
      callToAction: d.promotion.call_action,
      fullDescription: d.promotion.description,
      title: d.promotion.header,
      id: d.promotion.id,
      isActive: String(d.promotion.is_active).toLowerCase() === 'true',
      lang: d.promotion.lang,
      publicationDate: d.promotion.publication_date,
      selfDeletionDate: d.promotion.self_deletion_date,
      shortDescription: d.promotion.short_description,
      url: d.promotion.url,
      urlImage: d.promotion.url_image,
      urlMiniImage: d.promotion.url_mini_image,
    };
  };
}
